import { render, staticRenderFns } from "./PlanBoxPremium.vue?vue&type=template&id=684bbb3a&scoped=true&"
import script from "./PlanBoxPremium.vue?vue&type=script&lang=js&"
export * from "./PlanBoxPremium.vue?vue&type=script&lang=js&"
import style0 from "./PlanBoxPremium.vue?vue&type=style&index=0&id=684bbb3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684bbb3a",
  null
  
)

export default component.exports